import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '@src/environments/environment';

export type DigitalInspectionReportResult =
  | { available: true; data: any }
  | { available: false; reason: string };

@Injectable({
  providedIn: 'root'
})
export class DigitalInspectionApiService {

  constructor(private http: HttpClient) {
  }

  getAuthenticatedReport(vehicleUuid: string): Observable<DigitalInspectionReportResult> {
    return this.http.get<DigitalInspectionReportResult>(
      `${environment.apiUrl}/api/vehicles/${vehicleUuid}/digital-inspection-report`
    );
  }

  getPublicReport(vehicleUuid: string): Observable<DigitalInspectionReportResult> {
    return this.http.get<DigitalInspectionReportResult>(
      `${environment.apiUrl}/external/v2/digital-inspection-report/${vehicleUuid}`
    );
  }

  /** Proper A4 PDF of the report (same document for the dialog and the public link). */
  getAuthenticatedReportPdf(vehicleUuid: string, locale: string): Observable<Blob> {
    return this.http.get(
      `${environment.apiUrl}/api/vehicles/${vehicleUuid}/digital-inspection-report/pdf`,
      {params: new HttpParams().set('locale', locale), responseType: 'blob'}
    );
  }

  getPublicReportPdf(vehicleUuid: string, locale: string): Observable<Blob> {
    return this.http.get(
      `${environment.apiUrl}/external/v2/digital-inspection-report/${vehicleUuid}/pdf`,
      {params: new HttpParams().set('locale', locale), responseType: 'blob'}
    );
  }
}
